import { Collapse, List, ListItem, ListItemText } from '@mui/material'

import { IUserSessionsBaseWithUd } from 'src/types'
import { createFormData } from '../utils'

import { useStyles } from './styles'

interface IProps {
  open: boolean
  item: IUserSessionsBaseWithUd
}

const UserSessionItemCollapsed = ({ open, item }: IProps) => {
  const classes = useStyles()

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <List component="div" className={classes.collapseItemsWrapper}>
        {createFormData(item).map((item) => (
          <ListItem disablePadding>
            <ListItemText secondary={item.value} primary={item.field} />
          </ListItem>
        ))}
      </List>
    </Collapse>
  )
}

export { UserSessionItemCollapsed }
